import { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { logAnalyticsEvent } from "../Firebase";
import "../styles/Header.css";

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [roofingOpen, setRoofingOpen] = useState(false);
  const [constructionOpen, setConstructionOpen] = useState(false);
  const location = useLocation();

  const roofingLinks = [
    { label: "Commercial", to: "/commercial" },
    { label: "Residential", to: "/residential" },
    { label: "Inspections", to: "/inspections" },
  ];

  const constructionLinks = [
    { label: "Fencing", to: "/fencing" },
    { label: "Deck & Patio", to: "/deck-patio" },
    { label: "Siding", to: "/siding" },
    { label: "Interior Renovations", to: "/interior-renovations" },
  ];

  const navLinks = [
    { label: "Portfolio", to: "/portfolio" },
    { label: "FAQ", to: "/faq" },
  ];

  const isRoofingActive =
    location.pathname.startsWith("/commercial") ||
    location.pathname.startsWith("/residential") ||
    location.pathname.startsWith("/inspections");

  const isConstructionActive = constructionLinks.some((link) =>
    location.pathname.startsWith(link.to)
  );

  const handleNavClick = (label) => {
    logAnalyticsEvent("nav_click", {
      label,
      location: "header",
    });
  };

  return (
    <header className="site-header">
      <div className="header-inner">
        {/* Logo */}
        {/* Logo */}
<Link
  to="/"
  className="logo"
  aria-label="Crowned Roofing Home"
  onClick={() =>
    logAnalyticsEvent("nav_click", {
      label: "home_logo",
      location: "header",
    })
  }
>
  <span className="logo-stage" aria-hidden="true">
    <span className="logo-mark">
      <img src={process.env.PUBLIC_URL + "/logo-white-small.png"} alt="Crowned Roofing" />
    </span>

    <span className="logo-name">
      <span className="logo-name-inner">CROWNED ROOFING</span>
    </span>
  </span>
</Link>



        {/* Desktop Navigation */}
        <nav className="nav-desktop">
          <div
            className="nav-dropdown"
            onMouseLeave={() => setRoofingOpen(false)}
          >
            <button
              type="button"
              className={isRoofingActive ? "nav-link nav-dropdown-trigger active" : "nav-link nav-dropdown-trigger"}
              aria-haspopup="true"
              aria-expanded={roofingOpen}
              onClick={() => setRoofingOpen((open) => !open)}
              onMouseEnter={() => setRoofingOpen(true)}
            >
              Roofing
            </button>
            <div className={roofingOpen ? "nav-dropdown-menu open" : "nav-dropdown-menu"}>
              {roofingLinks.map((link) => (
                <NavLink
                  key={link.to}
                  to={link.to}
                  className={({ isActive }) =>
                    isActive ? "nav-dropdown-link active" : "nav-dropdown-link"
                  }
                  onClick={() => {
                    handleNavClick(link.label);
                    setRoofingOpen(false);
                  }}
                >
                  {link.label}
                </NavLink>
              ))}
            </div>
          </div>

          <div
            className="nav-dropdown"
            onMouseLeave={() => setConstructionOpen(false)}
          >
            <button
              type="button"
              className={isConstructionActive ? "nav-link nav-dropdown-trigger active" : "nav-link nav-dropdown-trigger"}
              aria-haspopup="true"
              aria-expanded={constructionOpen}
              onClick={() => setConstructionOpen((open) => !open)}
              onMouseEnter={() => setConstructionOpen(true)}
            >
              Construction
            </button>
            <div className={constructionOpen ? "nav-dropdown-menu open" : "nav-dropdown-menu"}>
              {constructionLinks.map((link) => (
                <NavLink
                  key={link.to}
                  to={link.to}
                  className={({ isActive }) =>
                    isActive ? "nav-dropdown-link active" : "nav-dropdown-link"
                  }
                  onClick={() => {
                    handleNavClick(link.label);
                    setConstructionOpen(false);
                  }}
                >
                  {link.label}
                </NavLink>
              ))}
            </div>
          </div>

          {navLinks.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              className={({ isActive }) =>
                isActive ? "nav-link active" : "nav-link"
              }
              onClick={() => handleNavClick(link.label)}
            >
              {link.label}
            </NavLink>
          ))}
        </nav>

        {/* Primary CTA */}
        <div className="header-cta">
          <Link
            to="/contact"
            className="btn btn-primary"
            onClick={() =>
              logAnalyticsEvent("contact_click", {
                source: "header",
              })
            }
          >
            Contact Us
          </Link>
        </div>

        {/* Mobile Menu Button */}
        <button
          className="mobile-menu-btn"
          aria-label="Toggle navigation"
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <span />
          <span />
          <span />
        </button>
      </div>

      {/* Mobile Navigation */}
      {menuOpen && (
        <nav className="nav-mobile">
          <div className="mobile-nav-group">
            <button
              type="button"
              className={isRoofingActive ? "nav-link mobile-nav-heading active" : "nav-link mobile-nav-heading"}
              aria-expanded={roofingOpen}
              onClick={() => setRoofingOpen((open) => !open)}
            >
              Roofing
            </button>
            {roofingOpen && (
              <div className="mobile-subnav">
                {roofingLinks.map((link) => (
                  <NavLink
                    key={link.to}
                    to={link.to}
                    className="nav-link mobile-subnav-link"
                    onClick={() => {
                      handleNavClick(link.label);
                      setRoofingOpen(false);
                      setMenuOpen(false);
                    }}
                  >
                    {link.label}
                  </NavLink>
                ))}
              </div>
            )}
          </div>

          <div className="mobile-nav-group">
            <button
              type="button"
              className={isConstructionActive ? "nav-link mobile-nav-heading active" : "nav-link mobile-nav-heading"}
              aria-expanded={constructionOpen}
              onClick={() => setConstructionOpen((open) => !open)}
            >
              Construction
            </button>
            {constructionOpen && (
              <div className="mobile-subnav">
                {constructionLinks.map((link) => (
                  <NavLink
                    key={link.to}
                    to={link.to}
                    className="nav-link mobile-subnav-link"
                    onClick={() => {
                      handleNavClick(link.label);
                      setConstructionOpen(false);
                      setMenuOpen(false);
                    }}
                  >
                    {link.label}
                  </NavLink>
                ))}
              </div>
            )}
          </div>

          {navLinks.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              className="nav-link"
              onClick={() => {
                handleNavClick(link.label);
                setMenuOpen(false);
              }}
            >
              {link.label}
            </NavLink>
          ))}

          <Link
            to="/contact"
            className="btn btn-primary mobile-cta"
            onClick={() => {
              logAnalyticsEvent("contact_click", {
                source: "header_mobile",
              });
              setMenuOpen(false);
            }}
          >
            Request an Inspection
          </Link>
        </nav>
      )}
    </header>
  );
}
